import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Investors\FinancingRequestWizardController::create
* @see app/Http/Controllers/Investors/FinancingRequestWizardController.php:49
* @route '//app.finesthub.de/financing-requests/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '//app.finesthub.de/financing-requests/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Investors\FinancingRequestWizardController::create
* @see app/Http/Controllers/Investors/FinancingRequestWizardController.php:49
* @route '//app.finesthub.de/financing-requests/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\FinancingRequestWizardController::create
* @see app/Http/Controllers/Investors/FinancingRequestWizardController.php:49
* @route '//app.finesthub.de/financing-requests/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Investors\FinancingRequestWizardController::create
* @see app/Http/Controllers/Investors/FinancingRequestWizardController.php:49
* @route '//app.finesthub.de/financing-requests/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Investors\FinancingRequestWizardController::storeWithPortfolioObject
* @see app/Http/Controllers/Investors/FinancingRequestWizardController.php:107
* @route '//app.finesthub.de/financing-requests/create/portfolio'
*/
export const storeWithPortfolioObject = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: storeWithPortfolioObject.url(options),
    method: 'post',
})

storeWithPortfolioObject.definition = {
    methods: ["post"],
    url: '//app.finesthub.de/financing-requests/create/portfolio',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Investors\FinancingRequestWizardController::storeWithPortfolioObject
* @see app/Http/Controllers/Investors/FinancingRequestWizardController.php:107
* @route '//app.finesthub.de/financing-requests/create/portfolio'
*/
storeWithPortfolioObject.url = (options?: RouteQueryOptions) => {
    return storeWithPortfolioObject.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\FinancingRequestWizardController::storeWithPortfolioObject
* @see app/Http/Controllers/Investors/FinancingRequestWizardController.php:107
* @route '//app.finesthub.de/financing-requests/create/portfolio'
*/
storeWithPortfolioObject.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: storeWithPortfolioObject.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Investors\FinancingRequestWizardController::storeWithNewProperty
* @see app/Http/Controllers/Investors/FinancingRequestWizardController.php:166
* @route '//app.finesthub.de/financing-requests/create/property'
*/
export const storeWithNewProperty = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: storeWithNewProperty.url(options),
    method: 'post',
})

storeWithNewProperty.definition = {
    methods: ["post"],
    url: '//app.finesthub.de/financing-requests/create/property',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Investors\FinancingRequestWizardController::storeWithNewProperty
* @see app/Http/Controllers/Investors/FinancingRequestWizardController.php:166
* @route '//app.finesthub.de/financing-requests/create/property'
*/
storeWithNewProperty.url = (options?: RouteQueryOptions) => {
    return storeWithNewProperty.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\FinancingRequestWizardController::storeWithNewProperty
* @see app/Http/Controllers/Investors/FinancingRequestWizardController.php:166
* @route '//app.finesthub.de/financing-requests/create/property'
*/
storeWithNewProperty.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: storeWithNewProperty.url(options),
    method: 'post',
})

const FinancingRequestWizardController = { create, storeWithPortfolioObject, storeWithNewProperty }

export default FinancingRequestWizardController